import React from 'react';
import PropTypes from 'prop-types';

function Previous({ size = 40, className, onClick }) {
  return (
    <svg className={className} width={size} height={size} onClick={onClick} style={{cursor: `pointer`}} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="20" fill="#242424"/>
      <path d="M23.41 24.59L18.83 20L23.41 15.41L22 14L16 20L22 26L23.41 24.59Z" fill="white"/>
    </svg>
  )
}

Previous.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired
}

export default Previous;
